import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="h-screen w-screen flex items-center justify-center text-slate-500" data-testid="auth-loading">
        Loading...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
